import { Injectable, Injector, inject } from '@angular/core';
import { AnalyticsService } from '../analytics/analytics.service';
import { UxGameController } from 'src/app/features/game/controllers/game/ux-game-controller';
import { UxGameFactory } from 'src/app/features/game/controllers/game/ux-game-factory';
import { GameId } from 'src/app/model/game/game-id';
import { HttpService } from '../http/http.service';
import { JobService } from '../job/job.service';
import { ProfileService } from '../profile/profile.service';
import { RoomService } from '../room/room.service';
import { ThemeService } from '../theme/theme.service';
import { TranslocoService } from '@jsverse/transloco';
import { TournamentService } from '../tournament/tournament.service';
import { AlertController, LoadingController, ModalController, Platform } from '@ionic/angular';
import { CurrencyPipe } from '@angular/common';
import { Router } from '@angular/router';
import { OperatorService } from '../operator/operator.service';
import { DemoRoomService } from '../demo-room-service/demo-room.service';
import { ActionBus } from 'game-logic';
import { UxGameServiceAction } from './ux-game-service-action';
import { RoomListService } from '../room-list/room-list.service';
import { AlertManagerService } from '../alert-stack-manager/alert-stack-manager.service';

@Injectable({
  providedIn: 'root',
})
export class UxGameService {
  private analyticsService = inject(AnalyticsService);
  private demoRoomService = inject(DemoRoomService);
  private httpService = inject(HttpService);
  private jobService = inject(JobService);
  private operatorService = inject(OperatorService);
  private profileService = inject(ProfileService);
  private roomService = inject(RoomService);
  private roomListService = inject(RoomListService);
  private themeService = inject(ThemeService);
  private translocoService = inject(TranslocoService);
  private tournamentService = inject(TournamentService);
  private alertManagerService = inject(AlertManagerService);
  private alertController = inject(AlertController);
  private loadingController = inject(LoadingController);
  private modalController = inject(ModalController);
  private currencyPipe = inject(CurrencyPipe);
  private injector = inject(Injector);
  private platform = inject(Platform);
  private router = inject(Router);

  private gameServiceActionBus = new ActionBus<UxGameServiceAction>();

  public createGame(gameId: GameId): UxGameController {
    this.gameServiceActionBus = new ActionBus<UxGameServiceAction>();

    return UxGameFactory.createGame(gameId, this.gameServiceActionBus, {
      analyticsService: this.analyticsService,
      demoRoomService: this.demoRoomService,
      httpService: this.httpService,
      jobService: this.jobService,
      operatorService: this.operatorService,
      profileService: this.profileService,
      roomService: this.roomService,
      roomListService: this.roomListService,
      themeService: this.themeService,
      translocoService: this.translocoService,
      tournamentService: this.tournamentService,
      alertManagerService: this.alertManagerService,
      alertController: this.alertController,
      loadingController: this.loadingController,
      modalController: this.modalController,
      currencyPipe: this.currencyPipe,
      injector: this.injector,
      platform: this.platform,
      router: this.router,
    });
  }

  public resetToLoading(): void {
    this.gameServiceActionBus.emit('resetToLoading');
  }

  public launchPracticeGame(rewardCents: number, entryFeeCents: number): void {
    this.gameServiceActionBus.emit('launchPracticeGame', {
      rewardCents,
      entryFeeCents,
    });
  }

  public launchLocalGame(logicSeed?: number): void {
    this.gameServiceActionBus.emit('launchLocalGame', {
      logicSeed,
    });
  }

  public launchPaidGame(roomId: string): void {
    this.gameServiceActionBus.emit('launchPaidGame', {
      roomId,
    });
  }
}
